<script>
  import { onDestroy, onMount } from "svelte";
  import { todosModalItemStore } from "../../../modals/TodosModal/stores";
  import UploadsButton from "./UploadsButton.svelte";
  import UploadsModal from "./UploadsModal.svelte";
  import {
    isDraggingFilesStore,
    selectedProjectIdsStore,
    uploadsModalStore,
  } from "./stores";

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer?.types?.includes("Files")) {
      if (!$uploadsModalStore) {
        uploadsModalStore.set(true);
      }
      isDraggingFilesStore.set(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.relatedTarget === null) {
      isDraggingFilesStore.set(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    isDraggingFilesStore.set(false);
  };

  onMount(() => {
    if (window.location.pathname === "/upload") return;

    document.addEventListener("dragenter", handleDragEnter);
    document.addEventListener("dragleave", handleDragLeave);
    document.addEventListener("dragover", handleDragOver);
    document.addEventListener("drop", handleDrop);
    const params = new URLSearchParams(window.location.search);
    const candidateId = params.get("openContactModalWithId", false);
    if (candidateId) {
      todosModalItemStore.set({
        candidateId: candidateId,
        toDoId: null,
      });
      // Update the URL without reloading the page
      params.delete("openContactModalWithId");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
    if (window.location.pathname === "/project") {
      const projectId = params.get("projectId");
      if (projectId) {
        selectedProjectIdsStore.set([projectId]);
      }
    }
  });

  onDestroy(() => {
    if (window.location.pathname === "/upload") return;

    document.removeEventListener("dragenter", handleDragEnter);
    document.removeEventListener("dragleave", handleDragLeave);
    document.removeEventListener("dragover", handleDragOver);
    document.removeEventListener("drop", handleDrop);
  });
</script>

<UploadsButton />
{#if $uploadsModalStore}
  <UploadsModal />
{/if}
